export function formatEventDate(date: Date) {
  const day = date.getDate();
  const monthNames = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ];
  const monthNamesFull = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ];
  const weekdayNames = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  const weekdayAbbr = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

  const month = monthNames[date.getMonth()];
  const monthFull = monthNamesFull[date.getMonth()];
  const weekday = weekdayNames[date.getDay()];
  const weekdayShort = weekdayAbbr[date.getDay()];
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;

  return {
    day : day.toString(),
    month,
    monthFull,
    weekday,
    weekdayShort,
    time
  };
}
